import { render, staticRenderFns } from "./sr_reference.vue?vue&type=template&id=425d7ce2&scoped=true"
import script from "./sr_reference.vue?vue&type=script&lang=js"
export * from "./sr_reference.vue?vue&type=script&lang=js"
import style0 from "./sr_reference.vue?vue&type=style&index=0&id=425d7ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425d7ce2",
  null
  
)

export default component.exports